import { createFileRoute } from '@tanstack/react-router'
import { TutorialsPage } from '@/features/tutorials'
import { RequirePermission } from '@/features/rbac/components/require-permission'

export const Route = createFileRoute('/_authenticated/tutorials')({
  component: () => (
    <RequirePermission permission='tutorial.view'>
      <TutorialsPage />
    </RequirePermission>
  ),
})
